import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const OfficeLocations = () => {
  const offices = [
    {
      name: 'Bangalore Office',
      address: 'Novel Office, Electronic City Phase 1, Bangalore, Karnataka - 560100',
      phone: '+91-9944562638',
      landline: '08772 220889',
      email: 'contact@adidartechindia.tech',
      colorClass: 'bg-cyan-50 border-cyan-600'
    },
    {
      name: 'Chennai Office',
      address: 'P.No.2B, KAKKANJI STREET, THARAPPAKKAM, PALLAVARAM TK, Thandalem, Kanchipuram, Sriperumbudur, Tamil Nadu, India, 600128',
      phone: '+91-9944562638',
      landline: '08772 220889',
      email: 'contact@adidartechindia.tech',
      colorClass: 'bg-blue-50 border-blue-600'
    },
    {
      name: 'Tirupati Office',
      address: 'Adidar Tech India Private Limited, Ground Floor, 22-8-257/M, 12th cross, Upadyada Nagar, Tirupati, Andhra Pradesh 517501',
      phone: '+91-9944562638',
      landline: '08772 220889',
      email: 'contact@adidartechindia.tech',
      colorClass: 'bg-purple-50 border-purple-600'
    }
  ];

  return (
    <div className="space-y-6">
      {offices.map((office) => (
        <div key={office.name} className={`${office.colorClass} p-6 rounded-xl border-l-4`}>
          <div className="flex items-start gap-3 mb-3">
            <MapPin className={`w-6 h-6 ${office.colorClass.split(' ')[0].replace('bg-', 'text-').replace('-50', '-600')} flex-shrink-0 mt-1`} />
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">{office.name}</h4>
              <p className="text-gray-600 mb-2">{office.address}</p>
              <div className="flex items-center gap-2 text-gray-700 mb-1">
                <Phone className="w-4 h-4" />
                <span>Ph: {office.phone}</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700 mb-2">
                <Phone className="w-4 h-4" />
                <span>Landline: {office.landline}</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <Mail className="w-4 h-4" />
                <span>{office.email}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OfficeLocations;
